import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";
import * as summaryReportAction from "../../../store/summary-report/action";

import {
  ADD_METER,
  DELETE_METER,
  GET_ALL_SELECT,
  GET_METER,
  baseUrl
} from "../../../helpers/url_api_constant";
import { AvField, AvForm } from "availity-reactstrap-validation";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
} from "reactstrap";
import ConfirmDialog, {
  useConfirmDialog,
} from "../../../components/Custom/ConfirmDialog";
import { Link, useHistory } from "react-router-dom";
import MessageDialog, {
  useModalShowMessage,
} from "../../../components/Custom/MessageDialog";
import React, { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";

import BootstrapTable from "react-bootstrap-table-next";
import CreatableSelect from "react-select/creatable";
import Flatpickr from "react-flatpickr";
import Loading from "../../../components/Custom/Loading";
import OverButton from "../../../components/Custom/Overbutton";
import PropTypes from "prop-types";
import Select from "react-select";
import { getPermission } from "../../../helpers/auth_helper";
import { getUserToken } from "../../../helpers/auth_helper";
import moment from "moment";
import { options } from '../../../common/data/projects';
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../../helpers/api_helper";
import { withTranslation } from "react-i18next";

//i18n

function Meter(props) {
  const newDate = new Date();
  newDate.setHours(0, 0, 0, 0);
  const dispatch = useDispatch();
  const searchObj = { ALIAS_NAME2: "", FULL_NAME: "", ALL_DELETE_FLAG: true, };
  const createObj = {
    PID: "", ALIAS_NAME: "", FULL_NAME: "", REMARK1_NAME: "", REMARK2_NAME: "", REMARK3_NAME: "", REMARK4_NAME: "", REMARK5_NAME: "", ZONE_PID: null, ZONE_NAME: "",
    POINT_PID: null, POINT_NAME: "", REGION_PID: null, REGION_NAME: "", AREA_PID: null, AREA_NAME: "", SUBAREA_PID: null, SUBAREA_NAME: "", BVZONE_PID: null, BVZONE_NAME: ""
    , BVVALVE_PID: null, BVVALVE_NAME: "", ESTATE_PID: null, ESTATE_NAME: "", COMTYPE_PID: null, COMTYPE_NAME: "", CUSTTYPE_PID: null, CUSTTYPE_NAME: "",
    QTYPOINT_PID: null, QTYPOINT_NAME: "", NOMINATE_PID: null, NOMINATE_NAME: "",
    REMARK1_PID: null, REMARK2_PID: null, REMARK3_PID: null, REMARK4_PID: null, REMARK5_PID: null, DELETE_FLAG: 0, START_DATE: newDate, END_DATE: null,
  };
  const permission = getPermission();
  // console.log(permission);
  const [readonly, setReadonly] = useState(false);
  const [pageAdd, setPageAdd] = useState(false);
  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);

  const [listCustomerType, setlistCustomerType] = useState([]);
  const [listArea, setlistArea] = useState([]);
  const [listSubArea, setlistSubArea] = useState([]);
  const [listZone, setlistZone] = useState([]);
  const [listPoint, setlistPoint] = useState([]);
  const [listEstate, setlistEstate] = useState([]);
  const [listRegion, setlistRegion] = useState([]);
  const [listBVZoning, setlistBVZoning] = useState([]);
  const [listBlockValve, setlistBlockValve] = useState([]);
  const [listNomination, setlistNomination] = useState([]);
  const [listQualityPoint, setlistQualityPoint] = useState([]);
  const [listCommunicationType, setlistCommunicationType] = useState([]);

  const [listRemark1, setListRemark1] = useState([]);
  const [listRemark2, setListRemark2] = useState([]);
  const [listRemark3, setListRemark3] = useState([]);
  const [listRemark4, setListRemark4] = useState([]);
  const [listRemark5, setListRemark5] = useState([]);

  const [userActionType, setUserActionType] = useState("");

  const listStatus = [
    { label: "Active", value: 0 },
    { label: "Inactive", value: 1 },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const {
    showMessage,
    toggleModalMessage,
    bodyMessageModal,
    titleMessageModal,
  } = useModalShowMessage();
  const { showConfirm, toggleConfirm, messageConfirm } = useConfirmDialog();
  //ฝั่งซ้ายคือ ตัวแปล ฝั่งขวา คือ ฟังก์ชั่น Ex  modelDeviceList เป็น ตัวแปลที่ใช้ ส่วน  setModelDeviceListเป็น ฟังก์ชั่นที่ใช้ Set Value ให้ modelDeviceList

  // DropDown
  const [dropDownCustomer, setDropDownCustomer] = useState(null);
  const [dropDownCustomerType, setDropDownCustomerType] = useState(null);
  const [dropDownCommunicationType, setDropDownCommunicationType] = useState(null);
  const [dropDownZone, setDropDownZone] = useState(null);
  const [dropDownPoint, setDropDownPoint] = useState(null);
  const [dropDownRegion, setDropDownRegion] = useState(null);
  const [dropDownNomination, setDropDownNomination] = useState(null);
  const [dropDownArea, setDropDownArea] = useState(null);
  const [dropDownSubArea, setDropDownSubArea] = useState(null);
  const [dropDownBVZoning, setDropDownBVZoning] = useState(null);
  const [dropDownBV, setDropDownBV] = useState(null);
  const [dropDownEstate, setDropDownEstate] = useState(null);
  const [dropDownQualityPoint, setDropDownQualityPoint] = useState(null);

  const [dropDownRemark1, setDropDownRemark1] = useState(null);
  const [dropDownRemark2, setDropDownRemark2] = useState(null);
  const [dropDownRemark3, setDropDownRemark3] = useState(null);
  const [dropDownRemark4, setDropDownRemark4] = useState(null);
  const [dropDownRemark5, setDropDownRemark5] = useState(null);
  // DropDown

  // DropDown Search
  const [dropDownSearchCustomer, setDropDownSearchCustomer] = useState(null);
  const [dropDownSearchCustomerType, setDropDownSearchCustomerType] =
    useState(null);
  const [dropDownSearchCommunicationType, setDropDownSearchCommunicationType] =
    useState(null);
  const [dropDownSearchZone, setDropDownSearchZone] = useState(null);
  const [dropDownSearchPoint, setDropDownSearchPoint] = useState(null);
  const [dropDownSearchRegion, setDropDownSearchRegion] = useState(null);
  const [dropDownSearchNomination, setDropDownSearchNomination] =
    useState(null);
  const [dropDownSearchArea, setDropDownSearchArea] = useState(null);
  const [dropDownSearchBVZoning, setDropDownSearchBVZoning] = useState(null);
  const [dropDownSearchBlockValve, setDropDownSearchBlockValve] = useState(null);
  const [dropDownSearchEstate, setDropDownSearchEstate] = useState(null);
  const [dropDownSearchQualityPoint, setDropDownSearchQualityPoint] =
    useState(null);

  const [dropDownSearchStatus, setDropDownSearchStatus] = useState(null);
  // DropDown Search

  // Handle Set Value DropDown Search //
  const handleSelectDropDownSearchCustomer = selected => {
    setDropDownSearchCustomer(selected);
  };
  const handleSelectDropDownSearchCustomerType = selected => {
    setDropDownSearchCustomerType(selected);
  };
  const handleSelectDropDownSearchCommunicationType = selected => {
    setDropDownSearchCommunicationType(selected);
  };
  const handleSelectDropDownSearchZone = selected => {
    setDropDownSearchZone(selected);
  };
  const handleSelectDropDownSearchPoint = selected => {
    setDropDownSearchPoint(selected);
  };
  const handleSelectDropDownSearchRegion = selected => {
    setDropDownSearchRegion(selected);
  };
  const handleSelectDropDownSearchNomination = selected => {
    setDropDownSearchNomination(selected);
  };
  const handleSelectDropDownSearchArea = selected => {
    setDropDownSearchArea(selected);
  };
  const handleSelectDropDownSearchBVZoning = selected => {
    setDropDownSearchBVZoning(selected);
  };
  const handleSelectDropDownSearchBV = selected => {
    setDropDownSearchBlockValve(selected);
  };
  const handleSelectDropDownSearchEstate = selected => {
    setDropDownSearchEstate(selected);
  };
  const handleSelectDropDownSearchQualityPoint = selected => {
    setDropDownSearchQualityPoint(selected);
  };

  const handleSelectDropDownSearchStatus = selected => {
    setDropDownSearchStatus(selected);
  };
  // Handle Set Value DropDown Search //

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }

  const listCustomer = [
    { label: "AAC", value: "AAC" },
    { label: "ABCT", value: "ABCT" },
    { label: "ABP2", value: "ABP2" },
    { label: "ABP2", value: "ABP2" },
  ];

  // const listCustomerType = [
  //   { label: "IND", value: "IND" },
  //   { label: "SPP", value: "SPP" },
  //   { label: "SUPPLIER", value: "SUPPLIER" },
  //   { label: "GSP", value: "GSP" },
  // ];

  const listData = [
    {
      Id: "1",
      Customer: "FreeText_1",
      CustomerName: "Mock up data 001",
      CustomerType: "IND",
      CommunicationType: "AMR",
      Zone: "EAST",
      Point: "Exit",
      Region: "Region 1",
      Nomination: "MTP",
      Area: "A1",
      BVZoning: "OCS1-BV6",
      BV: "BV2-BV3",
      Estate: "ESIE",
      QualityPoint: "BV6",
    },
    {
      Id: "2",
      Customer: "FreeText_2",
      CustomerName: "Mock up data 002",
      CustomerType: "IND",
      CommunicationType: "AMR",
      Zone: "EAST",
      Point: "Exit",
      Region: "Region 3",
      Nomination: "RIL",
      Area: "R",
      BVZoning: "Header",
      BV: "MTP",
      Estate: "RIL",
      QualityPoint: "RA6",
    },
    {
      Id: "3",
      Customer: "FreeText_3",
      CustomerName: "Mock up data 003",
      CustomerType: "SPP",
      CommunicationType: "RTU",
      Zone: "EAST",
      Point: "Exit",
      Region: "Region 1",
      Nomination: "ESIE",
      Area: "A1",
      BVZoning: "OCS2-BCS",
      BV: "BV6-BCS",
      Estate: "Suksawat",
      QualityPoint: "BV6",
    },
    {
      Id: "4",
      Customer: "FreeText_4",
      CustomerName: "Mock up data 004",
      CustomerType: "SPP",
      CommunicationType: "RTU",
      Zone: "EAST",
      Point: "Exit",
      Region: "Region 1",
      Nomination: "Suksawat",
      Area: "A1",
      BVZoning: "OCS2-BCS",
      BV: "BV6-BCS",
      Estate: "MTP",
      QualityPoint: "MTP",
    },
    {
      Id: "5",
      Customer: "FreeText_5",
      CustomerName: "Mock up data 005",
      CustomerType: "IND",
      CommunicationType: "AMR",
      Zone: "EAST",
      Point: "Exit",
      Region: "Region 1",
      Nomination: "ESIE",
      Area: "A1",
      BVZoning: "OCS1-BV6",
      BV: "BV2-BV3",
      Estate: "Suksawat",
      QualityPoint: "BV6",
    },
  ];

  // handleSelectDropDown  SetValue DropDown//
  const handleSelectDropDownCustomer = selected => {
    setDropDownCustomer(selected);
    // ค่า selected เป็นค่าที่เลือก จาก DropDown นำมา Set ในฟังก์ชั่น setDropDownCustomer นี้  เพื่อให้ตัวแปล ฝั่งซ้าย คือ ตัวนี้ dropDownCustomer ให้มันเท่ากับ  selected ค่าที่เลือกจาก DropDown
  };

  const handleSelectDropDownCustomerType = selected => {
    setDropDownCustomerType(selected);
  };

  const handleSelectDropDownCommunicationType = selected => {
    setDropDownCommunicationType(selected);
  };

  const handleSelectDropDownZone = selected => {
    setDropDownZone(selected);
  };

  const handleSelectDropDownPoint = selected => {
    setDropDownPoint(selected);
  };

  const handleSelectDropDownRegion = selected => {
    setDropDownRegion(selected);
  };

  const handleSelectDropDownNomination = selected => {
    setDropDownNomination(selected);
  };

  const handleSelectDropDownArea = selected => {
    setDropDownArea(selected);
  };

  const handleSelectDropDownSubArea = selected => {
    setDropDownSubArea(selected);
  };

  const handleSelectDropDownBVZoning = selected => {
    setDropDownBVZoning(selected);
  };

  const handleSelectDropDownBV = selected => {
    setDropDownBV(selected);
  };

  const handleSelectDropDownRemark1 = selected => {
    setDropDownRemark1(selected);
  };

  const handleSelectDropDownRemark2 = selected => {
    setDropDownRemark2(selected);
  };

  const handleSelectDropDownRemark3 = selected => {
    setDropDownRemark3(selected);
  };

  const handleSelectDropDownRemark4 = selected => {
    setDropDownRemark4(selected);
  };

  const handleSelectDropDownRemark5 = selected => {
    setDropDownRemark5(selected);
  };

  //Ex DropDown การทำ Create ใน DropDown ฟังก์ชั่นการดักค่า input
  const handleInputChangeDropDownBV = (inputValue, actionMeta) => {
    console.group("Input Changed");
    console.log(inputValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
  };

  const handleSelectDropDownEstate = selected => {
    setDropDownEstate(selected);
  };

  const handleSelectDropDownQualityPoint = selected => {
    setDropDownQualityPoint(selected);
  };

  // handleSelectDropDown  SetValue DropDown//

  //sort Column//
  const defaultSorted = [
    {
      dataField: "ALIAS_NAME",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "250",
        value: 250,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  // Action Button//
  const ButtonAction = (cellContent, row) => {
    return (
      <div className="d-sm-flex align-items-center justify-content-center">
        <OverButton
          onClick={() => {
            setReadonly(true);
            onEdit(row);
            setUserActionType("(View)");
          }}
          color="primary"
          icon="fas fa-eye"
          label="View"
        />
        {permission.eMET && (
          <>
            <OverButton
              onClick={() => {
                setReadonly(false);
                onEdit(row);
                setUserActionType("(Edit)");
              }}
              color="info"
              icon="far fa-edit"
              label="Edit"
            />
            {/* <OverButton
              onClick={() => {
                onDelete(row);
              }}
              color="danger"
              icon="fas fa-trash-alt"
              label="Delete"
            /> */}
          </>
        )}
      </div>
    );
  };

  const ActiveFlag = (cellContent, row) => {
    // console.log(row.END_DATE typeof)
    return (
      <div>
        {/* {permission.eMET && (
          <>
          </>
        )} */}
        {/* <div className="form-check form-switch form-switch-md align-items-center justify-content-start"
          style={{ paddingLeft: "3rem" }}>
          <input
            type="checkbox"
            className="form-check-input mt-0 ms-0 me-4"
            id="FlagActive"
            checked={row.DELETE_FLAG == 0}
            disabled  
            //={permission.eMET != true}
            // onChange={e => {
            //   setCreateModel({
            //     ...row,
            //     DELETE_FLAG: e.target.checked == true ? 0 : 1,
            //   })
            //   // updateDeleteFlag(row);
            // }}
            onChange={(e) => {
              updateDeleteFlag(e, row);
            }}
          />
        </div> */}
        <label
          className="form-check-label ms-0 mt-0 pd-0"
          htmlFor="FlagActive"
          style={{ cursor: "default" }}
        >
          {row.DELETE_FLAG == 1 && (
            <>
              {/* <span className="ms-0" style={{ color: "#DE1212", fontSize: "9px" }}> Active : {row.START_DATE != null && row.START_DATE != "Invalid Date" ? moment(row.START_DATE).format("DD/MM/YYYY") : "-"}</span> */}
              {/* <br />*/}
              <span className="ms-0" style={{ color: "#FF4545", fontSize: "12px" }}> Inactive: {row.END_DATE != null && row.END_DATE != "Invalid Date" ? moment(row.END_DATE).format("DD/MM/YYYY") : " -"} </span>
            </>
          )}
          {row.DELETE_FLAG == 0 && (
            <>
              <span className="ms-0" style={{ color: "#6EF649", fontSize: "12px" }}> Active: {row.START_DATE != null && row.START_DATE != "Invalid Date" ? moment(row.START_DATE).format("DD/MM/YYYY") : "-"} </span>
              {/* <br />
                Inactive :{row.END_DATE != null && row.END_DATE != "Invalid Date" ? moment(row.END_DATE).format("DD/MM/YYYY") : " -"} </span> */}
            </>
          )}
        </label>


        {/* 
        {(row.DELETE_FLAG == 0 || row.DELETE_FLAG == 2) && (
          <>
            <div className="ms-4 form-check form-check-outline form-check-primary">
              <input
                type="checkbox"
                className="form-check-input"
                checked={row.DELETE_FLAG == 2}
                id={row.PID}
                onChange={(e) => {
                  updateFlagCal(e, row);
                }}
              />
              <label
                className="form-check-label ms-0"
                style={{ color: "#F1948A" }}
                htmlFor={row.PID}
              >
                No Cal
              </label>
            </div>
          </>
        )} */}

      </div>
    );
  };

  // Action Button//

  const downloadExcel = async () => {
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/MeterApi/exportExcelMeter", {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.ms-excel',
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })
      // fetch("https://tsoopwb.pttplc.com/api/DownloadFile/DownloadBookingFile?szFileName=" + pid , {
      //   method: 'GET',
      //   headers: {
      //     'Content-Type': 'application/vnd.ms-excel',
      //     'Authorization':"Bearer " + accessToken.access_token
      //   },
      // })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          // dataDetailBooking.UPLOAD_FILE
          'Master_Data_Meter.xlsx'
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });
  };

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "2%",
        fontSize: "12px",
      },
      style: {
        width: "2%",
        fontSize: "12px",
      },
      formatter: CountIndexRow,
    },
    {
      dataField: "ALIAS_NAME",
      text: "Customer",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: true,
    },
    // {
    //   dataField: "FULL_NAME",
    //   text: "Customer Full Name",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "7%",
    //     fontSize: "10px",
    //   },
    //   style: {
    //     width: "7%",
    //   },
    //   sort: true,
    // },
    {
      dataField: "CUSTTYPE",
      text: "Customer Type",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "COMTYPE",
      text: "Communication Type",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "ZONE",
      text: "Zone",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "POINT",
      text: "Point",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "REGION",
      text: "Region",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "NOMINATE",
      text: "Nomination",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "AREA",
      text: "Area",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: true,
    },
    // {
    //   dataField: "SUB_AREA",
    //   text: "Sub Area",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "5%"
    //   },
    //   sort: true,
    // },
    {
      dataField: "BVZONE",
      text: "BV Zoning",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "BVVALVE",
      text: "Block Valve",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: true,
    },
    // {
    //   dataField: "ESTATE",
    //   text: "Industrial Estate",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "6%",
    //     fontSize: "12px",
    //   },
    //   style: {
    //     width: "6%",
    //   },
    //   sort: true,
    // },
    {
      dataField: "QTYPOINT",
      text: "Quality Point",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "8%",
        fontSize: "12px",
      },
      style: {
        width: "8%",
        fontSize: "12px",
      },
      sort: true,
    },
    // {
    //   dataField: "REMARK1",
    //   text: "Remark 1",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "6%"
    //   },
    //   sort: true,
    // },
    // {
    //   dataField: "REMARK2",
    //   text: "Remark 2",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "6%"
    //   },
    //   sort: true,
    // },
    // {
    //   dataField: "REMARK3",
    //   text: "Remark 3",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "6%"
    //   },
    //   sort: true,
    // },
    // {
    //   dataField: "REMARK4",
    //   text: "Remark 4",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "6%"
    //   },
    //   sort: true,
    // },
    // {
    //   dataField: "REMARK5",
    //   text: "Remark 5",
    //   headerAlign: "center",
    //   align: "center",
    //   headerStyle: {
    //     width: "6%"
    //   },
    //   sort: true,
    // },
    {
      dataField: "Active",
      text: "Status",
      headerAlign: "center",
      formatter: ActiveFlag,
      isDummyField: true,
      align: "center",
      headerStyle: {
        width: "7%",
        fontSize: "12px",
      },
      style: (cell, row, rowIndex, colIndex) => {
        // if (row.PRIORITY_FLAG != 1) {
        //   return {
        //     width: "20%",
        //     fontSize: "12px",
        //     cursor: "pointer",
        //   };
        // }
        return {
          width: "7%",
          fontSize: "12px",
          cursor: "default",
        };
      },
      // style: {
      //   width: "7%",
      //   fontSize: "12px",
      // },
      sort: false,
    },
    {
      dataField: "df1",
      text: "Action",
      isDummyField: true,
      headerAlign: "center",
      headerStyle: {
        width: "3%",
        fontSize: "12px",
      },
      style: {
        fontSize: "12px",
        width: "3%",
        paddingLeft: "0.7%",
        paddingRight: "0.5%"
      },
      formatter: ButtonAction,
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    //userEffect คือทำงานคล้ายๆ onInIt หมายถึงว่า พอมีการเรียกเข้า การใช้งานใน Component นี้จะทำอันนี้เป็นอันแรก//
    fetchData(searchObj);
    resetSearch();

    ///fixed header table
    let tableId = "meter-table";
    let scrollY = 447;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };

  }, []);
  //onInit//

  // useEffect(function () {
  //   console.log(createModel.END_DATE)
  //   console.log(createModel.START_DATE)
  // }, [createModel.END_DATE]);


  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };

  const compare = (a, b) => {
    // console.log(a, b);
    if (a.ALIAS_NAME < b.ALIAS_NAME) {
      return -1;
    }
    if (a.ALIAS_NAME > b.ALIAS_NAME) {
      return 1;
    }
    return 0;
  }
  // objs.sort((a,b) => (a.last_nom > b.last_nom) ? 1 : ((b.last_nom > a.last_nom) ? -1 : 0));

  const fetchData = async (searchData) => {
    setIsLoading(true);
    try {
      // objs.sort( compare );
      // console.log(objs);
      let option = await post(GET_ALL_SELECT);
      // console.log(option);
      setlistZone(option.data.zoneList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistPoint(option.data.pointList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistRegion(option.data.regionList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistArea(option.data.areaList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistSubArea(option.data.subAreaList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistBVZoning(option.data.bvZoneList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistBlockValve(option.data.bvValueList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistEstate(option.data.eStateList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistCommunicationType(option.data.ctCommuList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistCustomerType(option.data.customerTypeList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistQualityPoint(option.data.qtyPointList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setlistNomination(option.data.nominateList.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));

      setListRemark1(option.data.remark1List.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setListRemark2(option.data.remark2List.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setListRemark3(option.data.remark3List.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setListRemark4(option.data.remark4List.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));
      setListRemark5(option.data.remark5List.sort(compare).map((obj) => ({ label: obj.ALIAS_NAME, value: obj.PID })));

      let meter = await post(GET_METER, searchData);
      let meterList = meter.data.MeterList.map((obj) => {

        let startDate = moment(obj.START_DATE).toDate();
        let endDate = moment(obj.END_DATE).toDate();

        let zone = option.data.zoneList.find((zone) => zone.PID == obj.ZONE_PID);
        if (zone != undefined) {
          zone = zone.ALIAS_NAME;
        }
        // console.log(zone,option.data.zoneList);

        let point = option.data.pointList.find((point) => point.PID == obj.POINT_PID);
        if (point != undefined) {
          point = point.ALIAS_NAME;
        }
        // console.log(point, option.data.pointList);

        let region = option.data.regionList.find((region) => region.PID == obj.REGION_PID);
        if (region != undefined) {
          region = region.ALIAS_NAME;
        }
        // console.log(region, option.data.regionList);

        let area = option.data.areaList.find((area) => area.PID == obj.AREA_PID);
        if (area != undefined) {
          area = area.ALIAS_NAME;
        }
        // console.log(area,option.data.areaList);

        let subArea = option.data.subAreaList.find((subArea) => subArea.PID == obj.SUBAREA_PID);
        if (subArea != undefined) {
          subArea = subArea.ALIAS_NAME;
        }
        // console.log(area,option.data.areaList);

        let bvZone = option.data.bvZoneList.find((bvZone) => bvZone.PID == obj.BVZONE_PID);
        if (bvZone != undefined) {
          bvZone = bvZone.ALIAS_NAME;
        }
        // console.log(bvZone,option.data.areaList);

        let bvValve = option.data.bvValueList.find((bvValve) => bvValve.PID == obj.BVVALVE_PID);
        if (bvValve != undefined) {
          bvValve = bvValve.ALIAS_NAME;
        }
        // console.log(bvValve,option.data.bvValueList);

        let estate = option.data.eStateList.find((estate) => estate.PID == obj.ESTATE_PID);
        if (estate != undefined) {
          estate = estate.ALIAS_NAME;
        }
        // console.log(estate,option.data.estateList);

        let commu = option.data.ctCommuList.find((commu) => commu.PID == obj.COMTYPE_PID);
        if (commu != undefined) {
          commu = commu.ALIAS_NAME;
        }
        // console.log(commu,option.data.ctCommuList);

        let customerType = option.data.customerTypeList.find((customerType) => customerType.PID == obj.CUSTTYPE_PID);
        if (customerType != undefined) {
          customerType = customerType.ALIAS_NAME;
        }
        // console.log(customerType,option.data.customerTypeList);

        let qtyPoint = option.data.qtyPointList.find((qtyPoint) => qtyPoint.PID == obj.QTYPOINT_PID);
        if (qtyPoint != undefined) {
          qtyPoint = qtyPoint.ALIAS_NAME;
        }
        // console.log(qtyPoint,option.data.qtyPointList);

        let nomination = option.data.nominateList.find((nomination) => nomination.PID == obj.NOMINATE_PID);
        if (nomination != undefined) {
          nomination = nomination.ALIAS_NAME;
        }
        // console.log(nomination,option.data.nominateList);

        let remark1 = option.data.remark1List.find((remark1) => remark1.PID == obj.REMARK1_PID);
        if (remark1 != undefined) {
          remark1 = remark1.ALIAS_NAME;
        }

        let remark2 = option.data.remark2List.find((remark2) => remark2.PID == obj.REMARK2_PID);
        if (remark2 != undefined) {
          remark2 = remark2.ALIAS_NAME;
        }

        let remark3 = option.data.remark3List.find((remark3) => remark3.PID == obj.REMARK3_PID);
        if (remark3 != undefined) {
          remark3 = remark3.ALIAS_NAME;
        }

        let remark4 = option.data.remark4List.find((remark4) => remark4.PID == obj.REMARK4_PID);
        if (remark4 != undefined) {
          remark4 = remark4.ALIAS_NAME;
        }

        let remark5 = option.data.remark5List.find((remark5) => remark5.PID == obj.REMARK5_PID);
        if (remark5 != undefined) {
          remark5 = remark5.ALIAS_NAME;
        }

        return {
          ...obj, AREA: area, SUB_AREA: subArea, ZONE: zone, POINT: point, REGION: region, BVZONE: bvZone, BVVALVE: bvValve, ESTATE: estate, COMTYPE: commu, CUSTTYPE: customerType, QTYPOINT: qtyPoint,
          NOMINATE: nomination, REMARK1: remark1, REMARK2: remark2, REMARK3: remark3, REMARK4: remark4, REMARK5: remark5,
          START_DATE: startDate, END_DATE: endDate,
        }
      });
      // console.log(meterList);
      setModelDeviceList(meterList);
      resetModel();
    } catch (err) {
      toggleModalMessage(err.message);
    }
    setIsLoading(false);
  };

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    setDropDownSearchArea(null);
    setDropDownSearchCustomerType(null);
    setDropDownSearchCommunicationType(null);
    setDropDownSearchZone(null);
    setDropDownSearchPoint(null);
    setDropDownSearchRegion(null);
    setDropDownSearchNomination(null);
    setDropDownSearchBVZoning(null);
    setDropDownSearchBlockValve(null);
    setDropDownSearchEstate(null);
    setDropDownSearchQualityPoint(null);
    setDropDownSearchStatus(null);
    fetchData(searchObj);
  };

  const resetModel = () => {
    // console.log(listArea);
    setCreateModel(createObj);
    setDropDownArea(null);
    setDropDownSubArea(null);
    setDropDownCustomerType(null);
    setDropDownCommunicationType(null);
    setDropDownZone(null);
    setDropDownPoint(null);
    setDropDownRegion(null);
    setDropDownNomination(null);
    setDropDownBVZoning(null);
    setDropDownBV(null);
    setDropDownEstate(null);
    setDropDownQualityPoint(null);
    setDropDownRemark1(null);
    setDropDownRemark2(null);
    setDropDownRemark3(null);
    setDropDownRemark4(null);
    setDropDownRemark5(null);
  };

  const onSearch = () => {
    // console.log(searchModel);
    fetchData(searchModel);
  };

  const onAdd = () => {
    setReadonly(false);
    resetModel();
    setPageAdd(true);
    setUserActionType("(Add Record)");
  };

  const onEdit = row => {
    // console.log(row);
    setCreateModel(row);
    setDropDownZone(listZone.find(obj => obj.value == row.ZONE_PID));
    setDropDownPoint(listPoint.find(obj => obj.value == row.POINT_PID));
    setDropDownRegion(listRegion.find(obj => obj.value == row.REGION_PID));
    setDropDownArea(listArea.find(obj => obj.value == row.AREA_PID));
    setDropDownSubArea(listSubArea.find(obj => obj.value == row.SUBAREA_PID));
    setDropDownBVZoning(listBVZoning.find(obj => obj.value == row.BVZONE_PID));
    setDropDownBV(listBlockValve.find(obj => obj.value == row.BVVALVE_PID));
    setDropDownEstate(listEstate.find(obj => obj.value == row.ESTATE_PID));
    setDropDownCommunicationType(listCommunicationType.find(obj => obj.value == row.COMTYPE_PID));
    setDropDownCustomerType(listCustomerType.find(obj => obj.value == row.CUSTTYPE_PID));
    setDropDownQualityPoint(listQualityPoint.find(obj => obj.value == row.QTYPOINT_PID));
    setDropDownNomination(listNomination.find(obj => obj.value == row.NOMINATE_PID));

    setDropDownRemark1(listQualityPoint.find(obj => obj.value == row.REMARK1_PID));
    setDropDownRemark2(listQualityPoint.find(obj => obj.value == row.REMARK2_PID));
    // setDropDownRemark1(listRemark1.find(obj => obj.value == row.REMARK1_PID));
    // setDropDownRemark2(listRemark2.find(obj => obj.value == row.REMARK2_PID));
    setDropDownRemark3(listRemark3.find(obj => obj.value == row.REMARK3_PID));
    setDropDownRemark4(listRemark4.find(obj => obj.value == row.REMARK4_PID));
    setDropDownRemark5(listRemark5.find(obj => obj.value == row.REMARK5_PID));

    setPageAdd(true);
  };

  const onDelete = row => {
    setCreateModel(row);
    toggleConfirm("Do you want to delete ?");
  };

  const validateForm = () => {
    // console.log(createModel);
    let bResult = true;
    let element = document.querySelectorAll(".form-require")

    element.forEach(el => {
      if (el.classList.contains("is-invalid")) {
        el.classList.remove('is-invalid')
      }
    }
    );

    if (createModel.ALIAS_NAME == "") {
      bResult = false;
    }

    if (createModel.DELETE_FLAG == 0 && createModel.START_DATE == null) {
      document.querySelectorAll(".START_DATE").forEach(el => {
        el.classList.add('is-invalid')
      }
      );
      bResult = false;
    } else if (createModel.DELETE_FLAG == 1) {
      if (createModel.START_DATE != null && createModel.END_DATE == null) {
        document.querySelectorAll(".END_DATE").forEach(el => {
          el.classList.add('is-invalid')
        }
        );
        // console.log(document.querySelectorAll(".END_DATE"));
        // alert('test')
        bResult = false;
      }
      if (createModel.START_DATE == null && createModel.END_DATE != null) {
        document.querySelectorAll(".START_DATE").forEach(el => {
          el.classList.add('is-invalid')
        }
        );
        bResult = false;
      }
    }

    if (createModel.POINT_PID == "" || createModel.POINT_PID == null || createModel.POINT_PID == undefined) {
      document.getElementById("POINT_PID").classList.add('is-invalid');
      bResult = false;
    }

    if (createModel.REGION_PID == "" || createModel.REGION_PID == null || createModel.REGION_PID == undefined) {
      document.getElementById("REGION_PID").classList.add('is-invalid');
      bResult = false;
    }

    if (createModel.COMTYPE_PID == "" || createModel.COMTYPE_PID == null || createModel.COMTYPE_PID == undefined) {
      document.getElementById("COMTYPE_PID").classList.add('is-invalid');
      bResult = false;
    }

    if (createModel.CUSTTYPE_PID == "" || createModel.CUSTTYPE_PID == null || createModel.CUSTTYPE_PID == undefined) {
      document.getElementById("CUSTTYPE_PID").classList.add('is-invalid');
      bResult = false;
    }

    // if (createModel.QTYPOINT_PID == "" || createModel.QTYPOINT_PID == null || createModel.QTYPOINT_PID == undefined) {
    //   document.getElementById("QTYPOINT_PID").classList.add('is-invalid');
    //   bResult = false;
    // }

    // console.log(bResult);

    return bResult;
  };

  useEffect(function () {

    let ZONE_PID = dropDownZone != null ? dropDownZone.value : null;
    let ZONE_NAME = dropDownZone != null ? dropDownZone.label : null;

    let POINT_PID = dropDownPoint != null ? dropDownPoint.value : null;
    let POINT_NAME = dropDownPoint != null ? dropDownPoint.label : null;

    let REGION_PID = dropDownRegion != null ? dropDownRegion.value : null;
    let REGION_NAME = dropDownRegion != null ? dropDownRegion.label : null;

    let AREA_PID = dropDownArea != null ? dropDownArea.value : null;
    let AREA_NAME = dropDownArea != null ? dropDownArea.label : null;

    let SUBAREA_PID = dropDownSubArea != null ? dropDownSubArea.value : null;
    let SUBAREA_NAME = dropDownSubArea != null ? dropDownSubArea.label : null;

    let BVZONE_PID = dropDownBVZoning != null ? dropDownBVZoning.value : null;
    let BVZONE_NAME = dropDownBVZoning != null ? dropDownBVZoning.label : null;

    let BVVALVE_PID = dropDownBV != null ? dropDownBV.value : null;
    let BVVALVE_NAME = dropDownBV != null ? dropDownBV.label : null;

    let ESTATE_PID = dropDownEstate != null ? dropDownEstate.value : null;
    let ESTATE_NAME = dropDownEstate != null ? dropDownEstate.label : null;

    let COMTYPE_PID = dropDownCommunicationType != null ? dropDownCommunicationType.value : null;
    let COMTYPE_NAME = dropDownCommunicationType != null ? dropDownCommunicationType.label : null;

    let CUSTTYPE_PID = dropDownCustomerType != null ? dropDownCustomerType.value : null;
    let CUSTTYPE_NAME = dropDownCustomerType != null ? dropDownCustomerType.label : null;

    let QTYPOINT_PID = dropDownQualityPoint != null ? dropDownQualityPoint.value : null;
    let QTYPOINT_NAME = dropDownQualityPoint != null ? dropDownQualityPoint.label : null;

    let NOMINATE_PID = dropDownNomination != null ? dropDownNomination.value : null;
    let NOMINATE_NAME = dropDownNomination != null ? dropDownNomination.label : null;

    let REMARK1_PID = dropDownRemark1 != null ? dropDownRemark1.value : null;
    let REMARK1_NAME = dropDownRemark1 != null ? dropDownRemark1.label : null;

    let REMARK2_PID = dropDownRemark2 != null ? dropDownRemark2.value : null;
    let REMARK2_NAME = dropDownRemark2 != null ? dropDownRemark2.label : null;

    let REMARK3_PID = dropDownRemark3 != null ? dropDownRemark3.value : null;
    let REMARK3_NAME = dropDownRemark3 != null ? dropDownRemark3.label : null;

    let REMARK4_PID = dropDownRemark4 != null ? dropDownRemark4.value : null;
    let REMARK4_NAME = dropDownRemark4 != null ? dropDownRemark4.label : null;

    let REMARK5_PID = dropDownRemark5 != null ? dropDownRemark5.value : null;
    let REMARK5_NAME = dropDownRemark5 != null ? dropDownRemark5.label : null;

    setCreateModel(preVent => ({
      ...preVent, ZONE_PID: ZONE_PID, ZONE_NAME, POINT_PID, POINT_NAME, REGION_PID, REGION_NAME, AREA_PID, AREA_NAME, BVZONE_PID, BVZONE_NAME, BVVALVE_PID, BVVALVE_NAME,
      ESTATE_PID, ESTATE_NAME, COMTYPE_PID, COMTYPE_NAME, CUSTTYPE_PID, CUSTTYPE_NAME, QTYPOINT_PID, QTYPOINT_NAME, NOMINATE_PID, NOMINATE_NAME, SUBAREA_PID, SUBAREA_NAME,
      REMARK1_PID, REMARK1_NAME, REMARK2_PID, REMARK2_NAME, REMARK3_PID, REMARK3_NAME, REMARK4_PID, REMARK4_NAME, REMARK5_PID, REMARK5_NAME,
    }));
  }, [dropDownZone, dropDownPoint, dropDownRegion, dropDownArea, dropDownNomination, dropDownSubArea,
    dropDownBVZoning, dropDownBV, dropDownEstate, dropDownCustomerType, dropDownQualityPoint, dropDownCommunicationType, dropDownRemark1, dropDownRemark2,
    dropDownRemark3, dropDownRemark4, dropDownRemark5]);


  useEffect(function () {

    let ZONE_PID = dropDownSearchZone != null ? dropDownSearchZone.value : null;
    let POINT_PID = dropDownSearchPoint != null ? dropDownSearchPoint.value : null;
    let REGION_PID = dropDownSearchRegion != null ? dropDownSearchRegion.value : null;
    let AREA_PID = dropDownSearchArea != null ? dropDownSearchArea.value : null;
    let BVZONE_PID = dropDownSearchBVZoning != null ? dropDownSearchBVZoning.value : null;
    let BVVALVE_PID = dropDownSearchBlockValve != null ? dropDownSearchBlockValve.value : null;
    let ESTATE_PID = dropDownSearchEstate != null ? dropDownSearchEstate.value : null;
    let COMTYPE_PID = dropDownSearchCommunicationType != null ? dropDownSearchCommunicationType.value : null;
    let CUSTTYPE_PID = dropDownSearchCustomerType != null ? dropDownSearchCustomerType.value : null;
    let QTYPOINT_PID = dropDownSearchQualityPoint != null ? dropDownSearchQualityPoint.value : null;
    let NOMINATE_PID = dropDownSearchNomination != null ? dropDownSearchNomination.value : null;
    let DELETE_FLAG = dropDownSearchStatus != null ? dropDownSearchStatus.value : null;

    setSearchModel(preVent => ({
      ...preVent, ZONE_PID: ZONE_PID, POINT_PID, REGION_PID, AREA_PID, BVZONE_PID, BVVALVE_PID,
      ESTATE_PID, COMTYPE_PID, CUSTTYPE_PID, QTYPOINT_PID, NOMINATE_PID, DELETE_FLAG: DELETE_FLAG,
    }));
  }, [dropDownSearchZone, dropDownSearchPoint, dropDownSearchRegion, dropDownSearchArea, dropDownSearchNomination, dropDownSearchBVZoning, dropDownSearchBlockValve
    , dropDownSearchEstate, dropDownSearchCustomerType, dropDownSearchQualityPoint, dropDownSearchCommunicationType, dropDownSearchStatus]);

  const saveData = async () => {
    // console.log(createModel);
    let dataCreate = { ...createModel, START_DATE: moment(createModel.START_DATE).format("YYYY-MM-DD"), END_DATE: createModel.END_DATE != null ? moment(createModel.END_DATE).format("YYYY-MM-DD") : null }

    // console.log(dataCreate);
    if (validateForm()) {
      setIsLoading(true);
      try {
        let res = await post(ADD_METER, dataCreate);
        // console.log(res);
        if (res.resultCode == 200) {
          res.isEditMode == 0 ? toggleModalMessage("Save success.") : toggleModalMessage("Update success.");
          setPageAdd(false);
          fetchData(searchModel);
        } else {
          toggleModalMessage(res.resultDescription);
        }
      } catch (err) {
        toggleModalMessage(err.message);
      }
      setIsLoading(false);
    }
  };

  const updateDeleteFlag = async (e, row) => {
    // console.log(e.target.checked)
    if (e.target.checked == false) {
      let data = { ...row, DELETE_FLAG: e.target.checked == true ? 0 : 1 }
      // console.log(data);
      dispatch(loadingAction.showLoading());
      try {
        let res = await post(ADD_METER, data);
        // console.log(res);
        if (res.resultCode == 200) {
          fetchData(searchModel);
        } else {
          dispatch(messageAction.showMessage(res.resultDescription));
        }
      } catch (err) {
        dispatch(messageAction.showMessage(err.message));
        dispatch(loadingAction.hideLoading());
      }
      dispatch(loadingAction.hideLoading());
    } else {
      dispatch(messageAction.showMessage("กรุณาติดต่อ Admin เพื่อทำการเปิด Active"));
    }

  };

  const updateFlagCal = async (e, row) => {
    // console.log(e.target.checked)
    let data = { ...row, DELETE_FLAG: e.target.checked == true ? 2 : 0 }
    // console.log(data);
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(ADD_METER, data);
      // console.log(res);
      if (res.resultCode == 200) {
        fetchData(searchModel);
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (err) {
      dispatch(messageAction.showMessage(err.message));
      dispatch(loadingAction.hideLoading());
    }
    dispatch(loadingAction.hideLoading());
  };

  const deleteData = async (data) => {
    // console.log(data);
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(DELETE_METER, data);
      if (res.resultCode == 200) {
        // dispatch(messageAction.showMessage("Success."));
        fetchData(searchModel);
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
      dispatch(loadingAction.hideLoading());
    } catch (err) {
      dispatch(messageAction.showMessage(err.message));
      dispatch(loadingAction.hideLoading());
    }
  };
  //Function CURL

  // useEffect(function () {
  //   let data = createModel;
  //   // console.log(data);
  //   if (data.DELETE_FLAG == 0) {
  //     setCreateModel({ ...createModel, START_DATE: new Date(), END_DATE: null })
  //   } else {
  //     setCreateModel({ ...createModel, END_DATE: new Date() })
  //   }

  // }, [createModel.DELETE_FLAG]);

  function RenderList(prop) {
    // console.log(prop);
    return (
      <tr>
        <td>{prop.indexlist}</td>
        <td>{prop.data.MeterPointID}</td>
        <td>{prop.data.Customer}</td>
        <td>{prop.data.CustomerType}</td>
        <td>{prop.data.CommunicationType}</td>
        <td>{prop.data.Zone}</td>
        <td>{prop.data.Point}</td>
        <td>{prop.data.Region}</td>
        <td>{prop.data.Area}</td>
        <td>{prop.data.BVZoning}</td>
        <td>{prop.data.BV}</td>
        <td>
          <Button
            className="me-1"
            onClick={() => setPageAdd(true)}
            color="info"
          >
            <i className="far fa-edit"></i>
            &nbsp; Edit
          </Button>
          <Button
            onClick={() => setModalDelete(true)}
            // className="btn-rounded"
            color="danger"
          >
            <i className="fas fa-trash-alt"></i>
            &nbsp; Delete
          </Button>
        </td>
      </tr>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  {/* <CardTitle className="card-title mb-4 h4">
                    <h1 className="mb-0 font-size-20">
                      {props.t("Meter")}
                    </h1>
                  </CardTitle> */}

                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}
                      {props.t("Meter")}
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Master Data Setting
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">Meter</li>
                      </ol>
                    </div>
                  </div>
                  <hr />
                  <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Zone
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchZone}
                            onChange={handleSelectDropDownSearchZone}
                            options={listZone}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Point
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchPoint}
                            onChange={handleSelectDropDownSearchPoint}
                            options={listPoint}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Region
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchRegion}
                            onChange={handleSelectDropDownSearchRegion}
                            options={listRegion}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Area
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchArea}
                            onChange={handleSelectDropDownSearchArea}
                            options={listArea}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          BV Zoning
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchBVZoning}
                            onChange={handleSelectDropDownSearchBVZoning}
                            options={listBVZoning}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Block Valve
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchBlockValve}
                            onChange={handleSelectDropDownSearchBV}
                            options={listBlockValve}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Industrial Estate
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchEstate}
                            onChange={handleSelectDropDownSearchEstate}
                            options={listEstate}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Communication Type
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchCommunicationType}
                            onChange={
                              handleSelectDropDownSearchCommunicationType
                            }
                            options={listCommunicationType}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Customer Type
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchCustomerType}
                            onChange={handleSelectDropDownSearchCustomerType}
                            options={listCustomerType}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Quality Point
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchQualityPoint}
                            onChange={handleSelectDropDownSearchQualityPoint}
                            options={listQualityPoint}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Nomination
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchNomination}
                            onChange={handleSelectDropDownSearchNomination}
                            options={listNomination}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Customer
                        </Label>
                        <Col sm={8}>
                          {/* <form className="custom-search d-none d-lg-block p-0"> */}

                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                // style={{borderRadius:'0px'}}
                                type="text"
                                style={{ border: 'solid 1px #FFFFFF' }}
                                // style={{ backgroundColor: "#FFFFFF" }}
                                className="form-control rounded-2"
                                placeholder={props.t("Search Customer")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    ALIAS_NAME2: e.target.value,
                                  })
                                }
                                value={searchModel.ALIAS_NAME2}
                              />
                              <i className="bx bx-search-alt search-icon" />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              {/* <span className="bx bx-search-alt"></span> */}
                            </div>
                          </div>
                          {/* </form> */}
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          SCADA Tag
                        </Label>
                        <Col sm={8}>


                          <div className="search-box">
                            <div className="position-relative">
                              <input

                                type="text"
                                style={{ border: 'solid 1px #FFFFFF' }}

                                className="form-control rounded-2"
                                placeholder={props.t("Search SCADA Tag")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    FULL_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.FULL_NAME}
                              />
                              <i className="bx bx-search-alt search-icon" />

                            </div>
                          </div>

                        </Col>
                      </FormGroup>
                    </Col>
                  </Row> */}

                  <Row>
                    <Col sm="4">
                      <FormGroup className="row mt-2">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Status
                        </Label>
                        <Col sm={8}>
                          <Select
                            placeholder="All"
                            isClearable={true}
                            value={dropDownSearchStatus}
                            onChange={handleSelectDropDownSearchStatus}
                            options={listStatus}
                            classNamePrefix="select2-selection"
                            styles={SelectStyle}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="12">
                      <FormGroup className="row">
                        <Col sm={12}>
                          <div className="d-flex align-items-right justify-content-end">
                            <Button
                              color="info"
                              className="mt-2 mb-2"
                              onClick={() => onSearch()}
                            >
                              <i className="fas fa-search"></i>
                              &nbsp; Search
                            </Button>

                            <Button color="warning" className="mt-2 mb-2 ms-2" onClick={() => resetSearch()}>
                              <i className="fas fa-redo-alt"></i>
                              &nbsp; Reset
                            </Button>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="12">
                      <FormGroup className="row">
                        <Col sm={12}>
                          <div className="d-flex align-items-right justify-content-start">
                            {permission.eMET && (
                              <>
                                <Button
                                  onClick={() => onAdd()}
                                  // className="btn-rounded"
                                  color="success"
                                // className="mt-3"
                                >
                                  <i className="fas fa-plus"></i>
                                  &nbsp; Add
                                </Button>

                                <Button
                                  onClick={() => downloadExcel()}
                                  // className="btn-rounded"
                                  color="primary"
                                  className="ms-2"
                                >
                                  <i className="fas fa-file-download fa-lg"></i>
                                  &nbsp; Export Excel
                                </Button>
                              </>
                            )}
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="12" className="mt-2">
                      <div>
                        <BootstrapTable
                          id="meter-table"
                          keyField="PID"
                          data={modelDeviceList}
                          columns={columns}
                          defaultSorted={defaultSorted}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          pagination={paginationFactory(options)}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/*start : ModalPageAdd */}
      <Modal size="xl" isOpen={pageAdd}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Meter {userActionType}</h5>
        </div>
        <div className="modal-body">
          <CardBody className="p-1">
            <AvForm className="needs-validation">
              <Row>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>Customer</Label>
                    <div className="position-relative">
                      <AvField
                        // disabled
                        // style={{ border: "solid 1px #FFFFFF"}}
                        type="text"
                        // readOnly={readonly}
                        disabled={readonly == true || userActionType == "(Edit)"}
                        name="ALIAS_NAME"
                        errorMessage="Enter Customer"
                        className="form-control basicborder"
                        validate={{ required: { value: true } }}
                        onChange={e =>
                          setCreateModel({
                            ...createModel,
                            ALIAS_NAME: e.target.value,
                          })
                        }
                        value={createModel.ALIAS_NAME}
                      />
                    </div>
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label>Customer Full Name</Label>
                    <div className="position-relative">
                      <Input
                        type="text"
                        // readOnly={readonly}
                        disabled={readonly}
                        // name="FULL_NAME"
                        // errorMessage="Enter Customer Full Name"
                        className="form-control basicborder"
                        // validate={{ required: { value: true } }}
                        onChange={e =>
                          setCreateModel({
                            ...createModel,
                            FULL_NAME: e.target.value,
                          })
                        }
                        value={createModel.FULL_NAME}
                      />
                    </div>
                  </FormGroup>
                </Col>
                <Col md={2} className="d-flex align-items-center justify-content-center">
                  <FormGroup className="mb-1">
                    <Label>Meter Status</Label>
                    {/* <div className="d-flex align-items-center justify-content-center form-check form-switch form-switch-md p-0 m-0" dir="ltr">
                      <input
                        type="checkbox"
                        className="form-check-input mt-0 ms-3"
                        id="FlagCheckActive"
                        checked={createModel.DELETE_FLAG == 0}
                        // disabled={readonly}
                        disabled
                        style={{ cursor: readonly == true ? "default" : "pointer" }}
                        // onChange={e =>
                        //   setCreateModel({
                        //     ...createModel,
                        //     DELETE_FLAG: e.target.checked == true ? 0 : 1,
                        //     START_DATE: e.target.checked == true ? (createModel.START_DATE != null ? createModel.START_DATE : newDate) : createModel.START_DATE,
                        //     END_DATE: e.target.checked == true ? null : newDate,
                        //   })

                        //   // useEffect(function () {
                        //   //   let data = createModel;
                        //   //   // console.log(data);
                        //   //   if (data.DELETE_FLAG == 0) {
                        //   //     setCreateModel({ ...createModel, START_DATE: new Date(), END_DATE: null })
                        //   //   } else {
                        //   //     setCreateModel({ ...createModel, END_DATE: new Date() })
                        //   //   }

                        //   // }, [createModel.DELETE_FLAG]);

                        // }
                      />
                    </div> */}
                    {/* <label
                      className="d-flex align-items-center justify-content-center form-check-label mt-2"
                      htmlFor="FlagCheckActive"
                      style={{ cursor: readonly == true ? "default" : "pointer" }}
                    >
                      {createModel.DELETE_FLAG == 1 && (
                        <span className="ms-1" style={{ color: "#DE1212" }}>Inactive</span>
                      )}
                      {createModel.DELETE_FLAG == 0 && (
                        <span className="ms-1" style={{ color: "#387818" }}>Active</span>
                      )}
                    </label> */}

                    {createModel.DELETE_FLAG == 1 && (
                      <h2 className="ms-0" style={{ color: "#FF4545", borderColor: "#FFFFFF" }}>Inactive</h2>
                    )}
                    {createModel.DELETE_FLAG == 0 && (
                      <h2 className="ms-1" style={{ color: "#6EF649", borderColor: "#FFFFFF" }}>Active</h2>
                    )}

                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup className="mb-1 ">
                    <Label>Active Date</Label>
                    <Flatpickr
                      id="START_DATE"
                      className="START_DATE form-require form-control d-block"
                      placeholder="Select Date"
                      options={{
                        altInput: true,
                        // altFormat: "d/m/Y",
                        altFormat: "d/m/Y",
                        dateFormat: "d/m/Y",
                        maxDate: moment(createModel.END_DATE).add('day', -1).toDate(),
                      }}
                      disabled={readonly}
                      onChange={(value) => {
                        setCreateModel(
                          {
                            ...createModel,
                            START_DATE: value[0],

                          })
                      }}
                      value={createModel.START_DATE}
                    />
                  </FormGroup>
                </Col>
                <Col md={2}>
                  <FormGroup className="mb-1">
                    <Label> Inactive Date</Label>
                    <Flatpickr
                      // id="END_DATE"
                      // className="form-control "
                      className="END_DATE form-require form-control d-block"
                      placeholder="Select Date"
                      disabled={readonly}
                      options={{
                        altInput: true,
                        // altFormat: "d/m/Y",
                        altFormat: "d/m/Y",
                        dateFormat: "d/m/Y",
                        minDate: moment(createModel.START_DATE).add('day', 1).toDate(),
                      }}
                      onChange={(value) => {
                        setCreateModel(
                          {
                            ...createModel,
                            END_DATE: value[0],
                            DELETE_FLAG: value[0] > newDate ? 0 : 1, //e.target.checked == true ? 0 : 1,
                          })
                      }}
                      value={createModel.END_DATE}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <hr />

              <Row>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label>Zone</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownZone}
                      onChange={handleSelectDropDownZone}
                      options={listZone}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>Point</Label>
                    <Select
                      id="POINT_PID"
                      placeholder="( Blank )"
                      // error={true}
                      isDisabled={readonly}
                      isClearable
                      value={dropDownPoint}
                      onChange={handleSelectDropDownPoint}
                      options={listPoint}
                      classNamePrefix="form-require select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label>Area</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownArea}
                      onChange={handleSelectDropDownArea}
                      options={listArea}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label>Sub Area</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownSubArea}
                      onChange={handleSelectDropDownSubArea}
                      options={listSubArea}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label>BV Zoning</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownBVZoning}
                      onChange={handleSelectDropDownBVZoning}
                      options={listBVZoning}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label>Block Valve</Label>
                    <Select
                      // <CreatableSelect
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownBV}
                      onChange={handleSelectDropDownBV}
                      // onInputChange={handleInputChangeDropDownBV}
                      options={listBlockValve}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label>Industrial Estate</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownEstate}
                      onChange={handleSelectDropDownEstate}
                      options={listEstate}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>
                      Communication Type
                    </Label>
                    <Select
                      id="COMTYPE_PID"
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownCommunicationType}
                      onChange={handleSelectDropDownCommunicationType}
                      options={listCommunicationType}
                      classNamePrefix="form-require select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>Region</Label>
                    <Select
                      id="REGION_PID"
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownRegion}
                      onChange={handleSelectDropDownRegion}
                      options={listRegion}
                      classNamePrefix="form-require select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label><span style={{ color: "#FF0E03" }}>* </span>
                      Customer Type
                    </Label>
                    <Select
                      id="CUSTTYPE_PID"
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownCustomerType}
                      onChange={handleSelectDropDownCustomerType}
                      options={listCustomerType}
                      classNamePrefix="form-require select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label>Quality Point</Label>
                    <Select
                      // id="QTYPOINT_PID"
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownQualityPoint}
                      onChange={handleSelectDropDownQualityPoint}
                      options={listQualityPoint}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    //form-require 
                    />
                    {/* <Button variant="light">Light</Button> */}
                  </FormGroup>
                </Col>
                <Col md={3}>
                  <FormGroup className="mb-1">
                    <Label>Nomination</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownNomination}
                      onChange={handleSelectDropDownNomination}
                      options={listNomination}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <hr />
              <Row>
                <Col md={4}>
                  <FormGroup className="mb-1">
                    <Label>Quality Point ( Backup 1 )</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownRemark1}
                      onChange={handleSelectDropDownRemark1}
                      options={listQualityPoint}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="mb-1">
                    <Label>Quality Point ( Backup 2 )</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownRemark2}
                      onChange={handleSelectDropDownRemark2}
                      options={listQualityPoint}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="mb-1">
                    <Label>Remark 3</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownRemark3}
                      onChange={handleSelectDropDownRemark3}
                      options={listRemark3}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
              </Row>
              {/* <hr /> */}
              <Row>
                <Col md={4}>
                  <FormGroup className="mb-1">
                    <Label>Remark 4</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownRemark4}
                      onChange={handleSelectDropDownRemark4}
                      options={listRemark4}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup className="mb-1">
                    <Label>Remark 5</Label>
                    <Select
                      placeholder="( Blank )"
                      isDisabled={readonly}
                      isClearable
                      value={dropDownRemark5}
                      onChange={handleSelectDropDownRemark5}
                      options={listRemark5}
                      classNamePrefix="select2-selection"
                      styles={SelectStyle}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <hr />

              <div className="text-center mt-2">
                {!readonly &&
                  <button
                    type="submit"
                    className="btn btn-success me-2"
                    onClick={() => saveData()}
                  >
                    <i className="far fa-save"></i> Save
                  </button>
                }
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => setPageAdd(false)}
                >
                  <i className="fas fa-times"></i> Close
                </button>
              </div>
            </AvForm>
          </CardBody>


          {createModel.PID && (
            <Row className="mt-2">
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-start"
                  style={{ color: "#FFFFFF", fontSize: "16px" }} //#556ee6
                >
                  Create By : {createModel.CREATE_USER} (  {moment(createModel.CREATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )
                </span>
              </Col>
              <Col sm={6}>
                <span
                  className="d-flex align-items-center justify-content-end"
                  style={{ color: "#FFFFFF", fontSize: "16px" }} //#556ee6
                >
                  Update By :  {createModel.UPDATE_USER} (  {moment(createModel.UPDATE_DATE).format(
                    "D/MM/YYYY, H:mm:ss"
                  )} )

                </span>
              </Col>
            </Row>
          )}
        </div>
        {/* -- Model Footer-- */}
        {/* <div className="modal-footer">
                <button type="button" className="btn btn-success">Save</button>
                <button type="button" className="btn btn-light" onClick={() =>
                  this.setState({ modal_backdrop: false })
                }>Close</button>
              </div> */}
        {/* -- Model Footer-- */}
      </Modal>
      {/*end : PageAdd */}

      {/*Loading */}
      <Loading show={isLoading} />
      {/*Loading */}

      {/* MessageDialog */}
      <MessageDialog
        isOpen={showMessage}
        hide={toggleModalMessage}
        title={titleMessageModal}
        message={bodyMessageModal}
      />
      {/* comfirmDialog */}
      <ConfirmDialog
        isOpen={showConfirm}
        hide={toggleConfirm}
        message={messageConfirm}
        onConfirm={deleteData}
      />

    </React.Fragment>
  );
}

Meter.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ Meter }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Meter));

// ตัวอย่าง ที่1 เรียกหน้าแบบง่ายๆ Comment 2021-09-13//
// const Meter = () => {
//   return (
//     <React.Fragment>
//     <div className="page-content">
//       <Container fluid>
//         <h2>write Html code or structure</h2>
//       </Container>
//     </div>
//     </React.Fragment>
//   )
// }
// export default Meter;
// ตัวอย่าง ที่1 เรียกหน้าแบบง่ายๆ Comment 2021-09-13//

// ตัวอย่าง Table อันเก่า
{
  /* <Table className="table table-bordered mb-0"> */
}
{
  /* <thead className="table-light">
                            <tr>
                              <th>No.</th>
                              <th>Meter Point ID</th>
                              <th>Customer</th>
                              <th>Customer Type</th>
                              <th>Communication Type</th>
                              <th>Zone</th>
                              <th>Point</th>
                              <th>Region</th>
                              <th>Area</th>
                              <th>BV Zoning</th>
                              <th>BV</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {modelDeviceList.map((value, index) => (<RenderList key={index} data={value} indexlist={index + 1} />))}
                          </tbody> */
}
{
  /* </Table> */
}

// ตัวแท็บบาร์ข้างล่าง Table
// <br></br>
//                         <nav aria-label="Page navigation example">
//                           <ul className="pagination justify-content-end">
//                             <li className="page-item disabled">
//                               <a className="page-link">Previous</a>
//                             </li>
//                             <li className="page-item active">
//                               <a className="page-link">1</a>
//                             </li>
//                             <li className="page-item disabled">
//                               <a className="page-link">Next</a>
//                             </li>
//                           </ul>
//                         </nav>
